import { Observable } from 'rxjs';

export function isObservable(input: unknown): input is Observable<unknown> {
  return !!input && typeof (input as Observable<unknown>).subscribe === 'function' && typeof (input as Observable<unknown>).pipe === 'function';
}